<div class="token-unlock-container">
  
  <div class="title">
    {{"Cancelar token"|translate}}
  </div>
  <div class="message mt-3" style="font-family: Roboto; padding: 10px 30px;">
    {{"Esta"|translate}} <strong>{{"UI-WARNING-CANCEL-TOKEN-BOLD" | translate}}</strong>,
    {{"UI-WARNING-CANCEL-TOKEN" | translate }}.
  </div>

  <div class="btns-container mt-4">
    <button class="btn-outline-info btn resend-code" (click)="showModalForCode()">
      <ng-container *ngIf="resending; else resend">
        <div class="loading label-btn">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          {{"Canceling" | translate}}...
        </div>
      </ng-container >
      <ng-template #resend>
        <span style="font-size: 1rem;">{{'Cancelar token' | translate}}</span>
      </ng-template>


    </button>
    <button class="btn-primary btn"  (click)="closeModal()">
      {{"No por ahora"|translate}}
    </button>
  </div>
</div>
